import { routes } from '@/app/routing/router'
import { OtherErrorView } from './view'

const currentRoute = routes.otherError

const OtherErrorPageRoute = {
  route: currentRoute,
  view: OtherErrorView,
}

export { currentRoute, OtherErrorPageRoute }
